import { includes } from "lodash"

import { makeOptional } from "../routeHelper"

export const templates = {
  id: "administration",
  config: "/admin",
  build: () => "/admin",
  children: [
    {
      id: "adminOverview",
      config: "/admin/overview",
      build: () => "/admin/overview",
    },
    {
      id: "adminUsersOverview",
      config: "/admin/users",
      build: () => "/admin/users",
      children: [
        {
          id: "adminUsersEdit",
          config: "/admin/users/:id/:optional?",
          build: (id, optional) => `/admin/users/${id}${makeOptional(optional)}`,
        },
      ],
    },
    {
      id: "adminGroups",
      config: "/admin/groups",
      build: () => "/admin/groups",
      children: [
        {
          id: "adminGroupsEditor",
          config: "/admin/groups/:id",
          build: (id) => `/admin/groups/${id}`,
        },
        {
          id: "adminGroupsUsersOverview",
          config: "/admin/groups/:id/users",
          build: (id) => `/admin/groups/${id}/users`,
        },
      ],
    },
    {
      id: "adminObjectives",
      config: "/admin/objectives/repositories",
      build: () => "/admin/objectives/repositories",
      children: [
        {
          id: "adminObjectivesAddRepository",
          config: "/admin/objectives/repositories/addRepository",
          build: () => "/admin/objectives/repositories/addRepository",
        },
        {
          id: "adminObjectivesRepositories",
          config: "/admin/objectives/repositories/:id",
          build: (id) => `/admin/objectives/repositories/${id}`,
          children: [
            {
              id: "adminObjectivesRepositoryEdit",
              config: "/admin/objectives/repositories/:id/edit",
              build: (id) => `/admin/objectives/repositories/${id}/edit`,
            },
            {
              id: "adminObjectivesRepositoryImport",
              config: "/admin/objectives/repositories/:id/import",
              build: (id) => `/admin/objectives/repositories/${id}/import`,
            },
          ],
        },
      ],
    },
    {
      id: "adminRegionalSettings",
      config: "/admin/regionalsettings",
      build: () => "/admin/regionalsettings",
    },
    {
      id: "adminClusters",
      config: "/admin/clusters",
      build: () => "/admin/clusters",
    },
    {
      id: "adminContent",
      config: "/admin/content/:action?",
      build: (action) => `/admin/content/${action}`,
      children: [
        {
          build: (id) => `/admin/content/assessments/${id}/feedback`,
          config: "/admin/content/assessments/:id/feedback",
          id: "adminAssessmentsFeedback",
        },
      ],
    },
    {
      id: "adminAssessmentScales",
      config: "/admin/assessmentScales",
      build: () => "/admin/assessmentScales",
      children: [
        {
          id: "adminAssessmentScaleItem",
          config: "/admin/assessmentScales/item/:id",
          build: (id) => `/admin/assessmentScales/item/${id}`,
        },
      ],
    },
    {
      id: "adminSaml",
      config: "/admin/saml",
      build: () => "/admin/saml",
    },
    {
      id: "adminPlagiarism",
      config: "/admin/plagiarism",
    },
    {
      id: "adminTaxonomies",
      config: "/admin/taxonomies",
      build: () => "/admin/taxonomies",
      children: [
        {
          id: "adminTaxonomyItem",
          config: "/admin/taxonomies/item/:id",
          build: (id) => `/admin/taxonomies/item/${id}`,
        },
      ],
    },
    {
      id: "adminRoles",
      config: "/admin/roles/:action?",
      build: (action) => `/admin/roles/${action}`,
    },
    {
      id: "adminTrashcan",
      config: "/admin/trashcan/:action?",
      build: (action) => `/admin/trashcan/${action}`,
    },
    {
      id: "adminImsMappings",
      config: "/admin/imsMappings",
      build: () => "/admin/imsMappings",
    },
    {
      id: "adminSeb",
      config: "/admin/safe-exam-browser",
      build: () => "/admin/safe-exam-browser",
      children: [
        {
          id: "adminSebKey",
          config: "/admin/safe-exam-browser/:id",
          build: (id) => `/admin/safe-exam-browser/${id}`,
        },
      ],
    },
    {
      id: "adminExternalApi",
      config: "/admin/external-api",
      build: () => "/admin/external-api",
    },
    {
      id: "adminWebhooks",
      config: "/admin/webhooks",
      build: () => "/admin/webhooks",
      children: [
        {
          id: "adminWebhooksEdit",
          config: "/admin/webhooks/:id",
          build: (id) => `/admin/webhooks/${id}`,
        },
      ],
    },
    {
      id: "adminSiteGlobalSettings",
      config: "/admin/site-global-settings",
      build: () => "/admin/site-global-settings",
    },
    {
      id: "adminDefaultJsonSettings",
      config: "/admin/default-json-settings",
      build: () => "/admin/default-json-settings",
    },
    {
      id: "adminDefaultSettings",
      config: "/admin/default-settings",
      build: () => "/admin/default-settings",
      children: [
        {
          id: "adminDefaultSettingsQuestionEditor",
          config: "/admin/default-settings/question-editor/:type",
          build: (type, numericType, configured) => {
            const params = new URLSearchParams()
            if (numericType != null) params.set("type", String(numericType))
            if (configured != null) params.set("configured", configured ? "true" : "false")
            const qs = params.toString()
            return `/admin/default-settings/question-editor/${type}${qs ? `?${qs}` : ""}`
          },
        },
      ],
    },
    {
      id: "adminGlobalSettings",
      config: "/admin/global-settings",
      build: () => "/admin/global-settings",
    },
    {
      id: "adminLabels",
      config: "/admin/labels",
      build: () => "/admin/labels",
    },
    {
      id: "adminTemplates",
      config: "/admin/templates",
      build: () => "/admin/templates",
      children: [
        {
          id: "adminTemplatesType",
          config: "/admin/templates/:type/:id?",
          build: (type, id) => `/admin/templates/${type}/${id}`,
        },
      ],
    },

    {
      id: "adminSkins",
      config: "/admin/skins",
      build: () => "/admin/skins",
      children: [
        {
          id: "adminSkinEdit",
          config: "/admin/skins/edit/:id?",
          build: (id) => `/admin/skins/edit${makeOptional(id)}`,
        },
      ],
    },
    {
      id: "imslti",
      config: "/admin/imslti/:tab?",
      build: (tab = "integrations") => {
        const correctTypes = ["integrations", "settings"]

        if (!includes(correctTypes, tab)) {
          throw new Error(`IMS LTI tab: ${tab} isn't correct`)
        }

        return `/admin/imslti/${tab}`
      },
      children: [
        {
          id: "imsltiItem",
          config: "/admin/imslti/integrations/:id",
          build: (id) => `/admin/imslti/integrations/${id}`,
        },
      ],
    },
    {
      id: "adminDataCube",
      config: "/admin/data-cube",
      build: () => "/admin/data-cube",
    },
  ],
}
